import { Button } from '@components/atoms/button';
import styled from 'styled-components';

export const RequirementsButton = styled(Button)`
    font-size: 14px;
    line-height: 18px;
    border-bottom: 1px dashed ${(props) => props.theme.palette.primaryA1};
    padding: 0 2px;
    border-radius: 0;
    min-height: 20px;
    align-self: center;
`;
